<rt-report-parameters
    [controlNames]="controlNames"
    (getReport)="onGetReportClick($event)"
    (cancelReport)="onCancelClick()"
>
</rt-report-parameters>
<div *ngIf="displayReport">
    <dx-data-grid
        id="bdsReportGrid"
        [dataSource]="gridSource"
        height="91vh"
        minHeight="200px"
        [columnAutoWidth]="true"
        dataRowTemplate="dataRowTemplateName"
        (onContentReady)="onContentReady($event)"
    >
        <dxi-column caption="Master Trip">
            <dxi-column dataField="car_init" caption="Car ID"></dxi-column>
        </dxi-column>
        <dxi-column caption="Master Origin">
            <dxi-column dataField="ship_date_time" caption="Ship Date"></dxi-column>
            <dxi-column dataField="prev_trip_close_date_time" caption="Prev Cls"></dxi-column>
        </dxi-column>
        <dxi-column caption="Count">
            <dxi-column dataField="trip_cls_date_time" caption="Trip Cls"></dxi-column>
            <dxi-column dataField="one_way_round" caption="O/R"></dxi-column>
            <dxi-column dataField="orig_city" caption="Origin"></dxi-column>
        </dxi-column>
        <dxi-column dataField="dest_city" caption="Destination"></dxi-column>
        <dxi-column dataField="cust_type" caption="Customer Type"></dxi-column>
        <dxi-column dataField="idle_days" caption="Idle Days"></dxi-column>
        <dxi-column dataField="days_out" caption="Days Out"></dxi-column>
        <dxi-column dataField="hold_days" caption="Hold Days"></dxi-column>
        <dxi-column dataField="days_in" caption="Days In"></dxi-column>
        <dxi-column dataField="cust_name" caption="Customer"></dxi-column>
        <ng-container *dxTemplate="let item of 'dataRowTemplateName'">
            <tr class="main-row">
                <td>{{ item.data.master_trip_no }}</td>
                <td>{{ item.data.master_origin }}</td>
                <td></td>
                <td>{{ item.data.master_origin }}</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            <tr class="second-row">
                <td>{{ item.data.car_init }} {{ item.data.car_no }}</td>
                <td>{{ item.data.ship_date_time | date : 'MM/dd/yy' : 'UTC' }}</td>
                <td>{{ item.data.prev_trip_close_date_time | date : 'MM/dd/yy' : 'UTC' }}</td>
                <td>{{ item.data.trip_cls_date_time | date : 'MM/dd/yy' : 'UTC' }}</td>
                <td>{{ item.data.one_way_round }}</td>
                <td>{{ item.data.orig_city }} {{ item.data.orig_state }}</td>
                <td>{{ item.data.dest_city }} {{ item.data.dest_state }}</td>
                <td>{{ item.data.cust_type }}</td>
                <td>{{ item.data.idle_days }}</td>
                <td>{{ item.data.days_out }}</td>
                <td>{{ item.data.hold_days }}</td>
                <td>{{ item.data.days_in }}</td>
                <td>{{ item.data.cust_no }} {{ item.data.cust_name }}</td>
            </tr>
            <tr class="third-row">
                <td colspan="13"><b>Total Days this trip</b> {{ item.data | CalculateTotalDays }}</td>
            </tr>
        </ng-container>
    </dx-data-grid>
    <div style="text-align: right; padding: 10px; font-weight: bold">
        Total Count: {{ totalCount }}
    </div>
</div>
